import { FIELDTYPE } from "../../constants/field-type";
import { ERR_MSG } from "../../constants/error-msg";
import { isError, setAlert, setFormErrors, setFormInfo, setFormSignatories, setFormState } from "../../state/action";
import { addNewSubmittedForm, updateSubmittedForm } from "../../services/firebase/submittedForms/tb_submittedForms";
import dayjs from "dayjs";
import { STATUS } from '../../constants/form-status'
import { MODE } from "../../constants/form-mode";
import { ACTION } from "../../constants/form-action";
import { ALERT_TYPE } from "../../constants/alert-type";
import { convertToWords, createFormData, getExistingFileName } from "../../utils/utilities";
import { monetaryKeywords } from "../../pages/FormPage/specialFields";
import { constructFormData_toPDF, downloadBlobFile} from "../../pages/ViewPDFPage/pdfUtil";
import { uploadFile } from "../../services/real-star-api/file/upload-file";
import { checkIfFileExists } from "../../services/real-star-api/file/file-checker";
import { defaultForm, defaultType } from "../../constants/form-type";
import { GET_FILE_PATH } from "../../config/realstar-api-config";
import { post_submittedRecords } from "../../services/real-star-api/submit/submit";
// import { reconstruct_records } from "../../services/real-star-api/submit/post-utils";
import { fetchCurrentTransaction } from "../../services/firebase/api/fetch-transaction/submitted-form";
import { uploadPartiesFiles } from "./uploadUtils";

export const formValidation = (step, appState, dispatch, existingTransID, navigate, transactionID , action, signCanOverwrite , setTempFormState) => {

    switch (step) {
        case 0: //MAINFORM

            //if no selected form & type
            if (appState.formType.form === "" || appState.formType.type === "") {
                dispatch(isError({ show: true, errorMessage: "" }))
                return false
            } 

            const withUpdates = appState.formInfo.withUpdates;
            
            // if no changes made. 
            if (!withUpdates && action==="NEXT") {
                return true;
            }

            // for next page validation
            const mainStateErr = fieldValidations(appState.formState.mainValues, appState.formType.fields)
            const mainHasErrors = Object.values(mainStateErr).some((error) => error.trim() !== '');

            if (!mainHasErrors) {
                   
                    dispatch(isError({ show: false, errorMessage: "" }))
                    
                    //if made changes or updates, or the button === SUBMIT & NEXT
                if (withUpdates || action === "SUBMIT") {

                    const propertyAddress = setPropertyAddress(appState.formState.mainValues)
                    const currInText = convertCurrencyToWord(appState.formState.mainValues)
                    const salesPersonForCobroke = setSalesPersonForCoBroke(appState.formState.mainValues)

                    uploadPartiesFiles(appState.formState.mainValues, !existingTransID ? transactionID : existingTransID, appState.userDetails , dispatch , setAlert)
                        .then( partiesFilesLinks => {
                            //set the state first, before submit
                            dispatch(setFormState({
                                ...appState.formState,
                                mainValues: {
                                    ...appState.formState.mainValues,
                                    ...currInText,
                                    propertyAddress,
                                    ...salesPersonForCobroke,
                                    ...partiesFilesLinks,

                                }
                            }))

                            //show modal for the completed transaction.
                            dispatch(setAlert({
                                show: true,
                                title: 'Processing Form Submission',
                                body: `The form is currently being submitted. <br/> Kindly wait a moment.`,
                                showBtn: false
                            }))

                            //save To Firebase
                            addNewSubmittedForm({
                                Form: appState.formType.form,
                                Type: appState.formType.type,
                                TransactionId: transactionID,
                                Values: {
                                    ...appState.formState,
                                    mainValues: {
                                        ...appState.formState.mainValues,
                                        ...currInText,
                                        propertyAddress,
                                        ...salesPersonForCobroke,
                                        ...partiesFilesLinks,
                                    }
                                },
                                SelectedTemplates: appState.selectedTemplates,
                                SupportingDocuments: appState.supportingDocuments,
                                Status: STATUS.INCOMPLETE,
                                FormSignatories: signCanOverwrite ? [] : appState.formSignatories,
                                CreatedBy: appState.userDetails,
                                ModifiedBy: appState.userDetails,
                                Agent: appState.agentDetails,
                            })
                                .then((data) => {

                                    if (signCanOverwrite) {
                                        //reset form Signatories
                                        dispatch(setFormSignatories([]))
                                    }

                                    //if no existing ID, or newly submitted
                                    if (!existingTransID) {
                                        //redirection
                                        // navigate(`/edit/${transactionID}`);
                                        navigate(`/edit/${transactionID}`, {
                                            state: { step: 1 }
                                        });
                                    }

                                    //close modal for the completed transaction.
                                    dispatch(setAlert({
                                        show: false,
                                        title: "",
                                        body: "",
                                        showBtn: false

                                    }))

                                    //set form information state
                                    dispatch(setFormInfo({
                                        ...appState.formInfo,
                                        action: ACTION.VIEW,
                                        transactionID: transactionID,
                                        mode: MODE.EDIT,
                                        status: STATUS.INCOMPLETE,
                                        created: appState.formInfo.status === STATUS.NEW ?
                                            dayjs(new Date()).format('MMMM DD, YYYY hh:mm A') :
                                            dayjs(new Date(data.Created?.seconds * 1000)).format('MMMM DD, YYYY hh:mm A'),
                                        withUpdates: false
                                    }))

                                })
                                .catch((error) => {
                                    console.log(error)
                                    dispatch(setAlert({
                                        show: true,
                                        title: ALERT_TYPE.ERROR.toUpperCase(),
                                        body: ` ${error} </b>`
                                    }))
                                })



                            //set the temporary local state
                            setTempFormState({
                                ...appState.formState,
                                mainValues: {
                                    ...appState.formState.mainValues,
                                    ...currInText,
                                    propertyAddress,
                                }
                            })

                            //form errors set to default
                            dispatch(setFormErrors({ ...appState.formErrors, mainValues: {} }))
                            console.log('Submit data...')

                        })
                        .catch(error => {
                            dispatch(setAlert({
                                show: true,
                                title: ALERT_TYPE.ERROR.toUpperCase(),
                                body: ` ${error} <br></br><br></br> Please reupload the file.`
                            }))
                        })


                }

                return true;

            } else {
                dispatch(isError({ show: true, errorMessage: `Please complete all the required fields` }))
                dispatch(setFormErrors({ ...appState.formErrors, mainValues: mainStateErr }))
                return false;
            }


        case 1: //VIEW PDF PAGE
            const cobrokeCommissionValue = appState?.formState?.mainValues?.cobrokeGrossCommission
            const cobrokeTemplate = appState?.selectedTemplates?.find( x => x.includes("CB") && x.includes("AGREEMENT"))
            const TA_Template = appState?.selectedTemplates?.find( x => x.includes("TA") && x.includes("RESIDENTIAL LANDED"))
            
            //first validation
            if (parseInt(cobrokeCommissionValue) > 0) { //if there's a cobroke details
                if (!cobrokeTemplate) { // if no CB agreement templates
                    dispatch(setAlert({
                        show: true,
                        title: ALERT_TYPE.WARNING.toUpperCase(),
                        body: ` Please ensure you attach the relevant CB Agreement form.`
                    }))
                    return false;
                }
            }
            
            // if no TA attached for Rentals
            // if (!TA_Template && appState.formType.type === defaultType[1]) {
            //     dispatch(setAlert({
            //         show: true,
            //         title: ALERT_TYPE.WARNING.toUpperCase(),
            //         body: ` Please ensure to attach the appropriate TA Form.`
            //     }))
            //     return false;
            // }

            if (appState.selectedTemplates?.length > 0) {
                const withUpdates = appState.formInfo.withUpdates;
              
                //if made changes or updates, or the button === SUBMIT & NEXT
                if (withUpdates || action.includes("SUBMIT") || action === STATUS.SUBMITTED) {

                    dispatch(setAlert({
                        show: true,
                        title: 'Processing Form Submission',
                        body: `The form is currently being submitted. Kindly wait a moment.`,
                        showBtn: false
                    }))

                    //remove signatories on the unselected templates.
                    const newFormSignatories = removeSignatories(appState.formSignatories, appState.selectedTemplates);
                    dispatch(setFormSignatories(newFormSignatories))
                    
                    const selectedFormslinks = getLinkOfUploadedFiles(appState.selectedTemplates , transactionID)
                    const supportedDocumentslinks = getLinkOfSupportingDocuments(appState.supportingDocuments , transactionID)

                    addNewSubmittedForm({
                        Form: appState.formType.form,
                        Type: appState.formType.type,
                        TransactionId: transactionID,
                        Values: { ...appState.formState },
                        SelectedTemplates: appState.selectedTemplates,
                        SelectedTemplatesLink: [...selectedFormslinks], 
                        SharedForms: appState.sharedForms,
                        SupportingDocuments: appState.supportingDocuments,
                        SupportingDocumentsLink: supportedDocumentslinks,
                        Status: action === STATUS.SUBMITTED  ? STATUS.SUBMITTED : STATUS.INCOMPLETE ,
                        FormSignatories: newFormSignatories,
                        ModifiedBy: appState.userDetails,
                        Agent: appState.agentDetails
                    })
                        .then((data) => {
                            //upload files and download. 
                            uploadFilesToServer(appState , transactionID , dispatch, action).then( res => {
                                // if(action === STATUS.SUBMITTED){
                                //     dispatch(setFormInfo({ 
                                //         ...appState.formInfo, 
                                //         withUpdates: false, 
                                //         mode: MODE.CLOSED , 
                                //         status: STATUS.SUBMITTED 
                                //     }))

                                //     dispatch(setAlert({
                                //         show: true,
                                //         title: ALERT_TYPE.SUCCESS.toUpperCase(),
                                //         body: `The form has been submitted to accounts.`
                                //     }))

                                //     try{
                                //         //post API
                                //         // const newData = reconstruct_records(data);
                                //         fetchCurrentTransaction(transactionID).then( data => {
                                //             if(data){
                                //                 post_submittedRecords(data , data.id)
                                //                 console.log("Records successfully posted in RS API")
                                //             }
                                //         })
                             
                                //     }catch(err){
                                //         console.log(err)
                                //         console.log("error on posting records")
                                //     }
                                    
                                //     // navigate("/")
                                // }
                                // else {
                                //     dispatch(setAlert({
                                //         show: true,
                                //         title: ALERT_TYPE.SUCCESS.toUpperCase(),
                                //         body: `Selected forms has been uploaded.`
                                //     }))
                                //     dispatch(setFormInfo({ ...appState.formInfo, withUpdates: false, action: ACTION.VIEW  }))
                                // }


                                try {
                                    //post API
                                    // const newData = reconstruct_records(data);
                                    fetchCurrentTransaction(transactionID).then(data => {
                                        if (data) {
                                            post_submittedRecords(data, data.id)
                                            console.log("Records successfully posted in RS API")
                                        }
                                    })

                                } catch (err) {
                                    console.log(err)
                                    console.log("error on posting records")
                                }
                                
                                if(action === "SUBMIT_DOWNLOAD"){
                 
                                    dispatch(setAlert({
                                        show: true,
                                        title: ALERT_TYPE.SUCCESS.toUpperCase(),
                                        body: `The forms have been saved and downloaded successfully.`
                                    }))
                                    dispatch(setFormInfo({ ...appState.formInfo, withUpdates: false, action: ACTION.VIEW }))

                                    // navigate("/")

                                }else{
                                    dispatch(setAlert({
                                        show: true,
                                        title: ALERT_TYPE.SUCCESS.toUpperCase(),
                                        body: `The forms have been saved successfully.`
                                    }))
                                    dispatch(setFormInfo({ ...appState.formInfo, withUpdates: false, action: ACTION.VIEW }))
                                }
                            
                            })
                 
                
                        })
                        .catch((error) => {
                            console.log(error)
                            //show modal for the completed transaction.
                            dispatch(setAlert({
                                show: true,
                                title: ALERT_TYPE.ERROR.toUpperCase(),
                                body: `${error} </b>`
                            }))
                        })
                    // return true;
                }
                // return true;
            } else {
                dispatch(setAlert({
                    show: true,
                    title: ALERT_TYPE.ERROR.toUpperCase(),
                    body: `Please select a template.`
                }))
                return false;
            }

        case 2:
                //submit to accounts
                if (action === STATUS.SUBMITTED) {

                    dispatch(setAlert({
                        show: true,
                        title: 'Processing Form Submission',
                        body: `The form is currently being submitted. Kindly wait a moment.`,
                        showBtn: false
                    }))
                    
                    const selectedFormslinks = getLinkOfUploadedFiles(appState.selectedTemplates , transactionID)
                    const supportedDocumentslinks = getLinkOfSupportingDocuments(appState.supportingDocuments , transactionID)

                    addNewSubmittedForm({
                        Form: appState.formType.form,
                        Type: appState.formType.type,
                        TransactionId: transactionID,
                        Values: { ...appState.formState },
                        SelectedTemplates: appState.selectedTemplates,
                        SelectedTemplatesLink: [...selectedFormslinks], 
                        SharedForms: appState.sharedForms,
                        SupportingDocuments: appState.supportingDocuments,
                        SupportingDocumentsLink: supportedDocumentslinks,
                        Status: action === STATUS.SUBMITTED  ? STATUS.SUBMITTED : STATUS.INCOMPLETE ,
                        FormSignatories: appState.formSignatories,
                        ModifiedBy: appState.userDetails,
                        Agent: appState.agentDetails
                    })
                        .then((data) => {
                            //upload files and download. 
                            uploadFilesToServer(appState , transactionID , dispatch, action).then( res => {
                                if(action === STATUS.SUBMITTED){
                                    dispatch(setFormInfo({ 
                                        ...appState.formInfo, 
                                        withUpdates: false, 
                                        mode: MODE.CLOSED , 
                                        status: STATUS.SUBMITTED 
                                    }))

                                    dispatch(setAlert({
                                        show: true,
                                        title: ALERT_TYPE.SUCCESS.toUpperCase(),
                                        body: `The form has been submitted to accounts.`
                                    }))

                                    try{
                                        //post API
                                        // const newData = reconstruct_records(data);
                                        fetchCurrentTransaction(transactionID).then( data => {
                                            if(data){
                                                post_submittedRecords(data , data.id)
                                                console.log("Records successfully posted in RS API")
                                            }
                                        })
                             
                                    }catch(err){
                                        console.log(err)
                                        console.log("error on posting records")
                                    }
                                    
                                    // navigate("/")
                                }
                            })
                 
                
                        })
                        .catch((error) => {
                            console.log(error)
                            //show modal for the completed transaction.
                            dispatch(setAlert({
                                show: true,
                                title: ALERT_TYPE.ERROR.toUpperCase(),
                                body: `${error} </b>`
                            }))
                        })
                    // return true;
                }
        default:
            break;
    }
}

const removeSignatories = (signatories , templates) => {
    return signatories?.filter( i => templates.includes(i.formName) )
}

const setPropertyAddress = (value) => {
    const blk = value.blk || "" 
    const unit = value.unit || "" 
    const floor = value.floor || "" 
    const streetName = value.streetName || "" 

    return `${blk} ${unit} ${floor} ${streetName}`;
}

const setSalesPersonForCoBroke = (values) => {
    const { cobrokeCommissionDue , cobrokeAgentName, cobrokeAgentName_ID , cobrokeCompanyName } = values;

    if(cobrokeCommissionDue === "To"){
        if(cobrokeAgentName_ID){
            return { salesPersonForCobroke: cobrokeAgentName }
        }else{
            return { salesPersonForCobroke: cobrokeCompanyName }
        }
    }

}

const convertCurrencyToWord = (data) => {
    const newObj = {};
    for (let [key, value] of Object.entries(data)) {
        const isPriceOrAmountField = monetaryKeywords.some( keyword => 
            key?.toLowerCase().includes(keyword)
        );
        if(isPriceOrAmountField && !key.includes('InText') && !key.includes('Type')){
            newObj[key + 'InText'] = convertToWords(value ? value : "0")
        }
        if(key.includes('termsOfLease')){
            newObj[key + 'InText'] = convertToWords(value ? value : "0")
        }
    }
    return newObj;
}


export const fieldValidations = (formValues, formFields=[]) => {
    //if empty

    const formStateErr = {}
  
    formFields.length > 0 &&
        formFields.forEach((field) => {
            const { FieldName2, FieldType, IsRequired } = field;
            const fieldValue = formValues[FieldName2];
            
            if (IsRequired) {
                if (
                    (FieldType === FIELDTYPE.TEXT && fieldValue?.trim() === "")
                    ||
                    (FieldType === FIELDTYPE.LONG_TEXT && fieldValue?.trim() === "")
                    ||
                    (FieldType === FIELDTYPE.NUMBER && fieldValue?.trim() === "")
                    ||
                    (FieldType === FIELDTYPE.CURRENCY && fieldValue?.trim() === "")
                    ||
                    (FieldType === FIELDTYPE.DROP_DOWN && !fieldValue)
                    ||
                    (FieldType === FIELDTYPE.SINGLE_SELECT && !fieldValue)
                    ||
                    (FieldType === FIELDTYPE.MULTI_SELECT && !fieldValue)
                    ||
                    (FieldType === FIELDTYPE.DATE && !fieldValue)
                    ||
                    (FieldType === FIELDTYPE.RADIO && !fieldValue)
                ) {
                    formStateErr[FieldName2] = ERR_MSG.EMPTY
                }
            }

        })

    return formStateErr;
}

const uploadFilesToServer = async (appState , transactionID, dispatch , action) => {
    const {selectedTemplates , agentDetails , formSignatories, formTemplatesList , formType , formState} = appState; 
    const mainValues = formState.mainValues
    const agentValues = agentDetails

    const selectedFormTemplates = formTemplatesList.filter(val => 
        selectedTemplates.includes(val.FormName) && 
        formType.form === val.Form && 
        formType.type === val.Type
    );

    await uploadEachFile(selectedFormTemplates , mainValues , agentValues , formSignatories , transactionID , dispatch , action);
    // console.log(pdfBlob)
    return true;
}

const getSignatories = (file , formSignatories) => {
     
    const signatories = formSignatories?.find( form=> form.formId === file.Id);
    const signatoryValues = signatories?.signatoryValues || []
  
    return signatoryValues?.reduce((acc, item) => {
        acc[item.field + 'Signature'] = item[item.field + 'Signature'];
        acc[item.field + 'SignedDate'] = item[item.field + 'SignedDate'];
        return acc;
    }, {});
}

const uploadEachFile = async (selectedFormTemplates, mainValues, agentValues, formSignatories, transactionID, dispatch , action) => {
    let fileCount = 0;
    for (const file of selectedFormTemplates) {
        fileCount++;

        //without space // default to .pdf
        const existingFileName = getExistingFileName(file?.FormName)
        const existingFileURL = await checkIfFileExists(transactionID, existingFileName);


        const fieldSignatories = getSignatories(file, formSignatories);
        const newFileName = `${file?.FormName?.replace(/\s+/g, '')}.pdf`;
        const userEncryptedID = agentValues?.encrypted_id

        // if the file is not exists..
        if (!existingFileURL) {
            try {
                const PUBLIC_FOLDER = process.env.PUBLIC_URL;
                const templateLocalPath = PUBLIC_FOLDER + file.LocalPath

                const pdfBlob = await constructFormData_toPDF(
                    templateLocalPath, 
                    fieldSignatories,
                    mainValues,
                    agentValues
                );


                const formData = createFormData(pdfBlob, newFileName, transactionID)

                dispatch(setAlert({
                    show: true,
                    title: 'Saving The Forms',
                    body: `The forms are currently being saved. <br/>Please wait a moment. <br/><br/>
                           <b> ${fileCount}   /  ${selectedFormTemplates.length} forms. </b>
                        `,
                    showBtn: false
                }))

                console.log(`new file uploading... (${file.FormName})`)
                await uploadFile(formData, userEncryptedID); // Uncomment when ready to upload
                if(action.toUpperCase().includes("DOWNLOAD")){
                    await downloadBlobFile(pdfBlob , file.FormName);
                }

            } catch (error) {
                console.error('Error processing file:', file, error);
                dispatch(setAlert({
                    show: true,
                    title: 'Upload Error',
                    body: `File Upload Failed. Please try again. `,
                }))
            }
        }
        else{
            const cacheBustingURL = `${existingFileURL}?t=${new Date().getTime()}`
            const response = await fetch(cacheBustingURL);

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            try {
                const templateURL = await response?.url;
                const blob = await constructFormData_toPDF(templateURL,fieldSignatories, mainValues, agentValues); //plot the form data
                    
                const formData = createFormData(blob , newFileName, transactionID)
          
                dispatch(setAlert({
                    show: true,
                    title: 'Saving The Forms',
                    body: `The forms are currently being saved. <br/>Please wait a moment. <br/><br/>
                           <b> ${fileCount}   /  ${selectedFormTemplates.length} forms. </b>
                        `,
                    showBtn: false
                }))

                console.log(`existing file reuploading... (${file.FormName})` )
                await uploadFile(formData, userEncryptedID); // Uncomment when ready to upload

                if(action.toUpperCase().includes("DOWNLOAD")){ 
                    await downloadBlobFile(blob , file.FormName);
                }

            } catch (error) {
                console.log(error)
                dispatch(setAlert({
                    show: true,
                    title: ALERT_TYPE.ERROR.toUpperCase(),
                    body: `File Upload Failed. Please try again. <br/><br/> Filename: ${file.FormName}`,
                }))
            }
        }
    }
}

const getLinkOfUploadedFiles = (selectedTemplates, transactionID) => {
    const newFolderName = transactionID.toLowerCase()
    
    return selectedTemplates.map( form => {
        const newFileName = `${form.replace(/\s+/g, '')}.pdf`;
        return {
            fileName: form,
            link: `${GET_FILE_PATH}/${newFolderName}/${newFileName}`
        }
    })
}

const getLinkOfSupportingDocuments = ( supportingDocs, transactionID) => {
    const newFolderName = transactionID.toLowerCase()
    
    return supportingDocs.map( form => {
        const newFileName = form.FormName
        return {
            fileName: newFileName,
            link: `${GET_FILE_PATH}/${newFolderName}/${newFileName}`
        }
    })
}

